(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const allowMotion = !motionQuery.matches;
  const root = document.documentElement;
  const revealItems = Array.from(document.querySelectorAll('[data-ss-reveal]'));

  const showAllRevealItems = () => {
    revealItems.forEach((item) => {
      item.classList.remove('ss-await');
      item.classList.add('is-visible');
    });
  };

  if (allowMotion) {
    root.classList.add('ss-motion-ready');
    const viewportHeight = window.innerHeight || 1;

    revealItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const shouldWait = rect.top > viewportHeight * 0.92;

      if (shouldWait) {
        item.classList.add('ss-await');
      } else {
        item.classList.add('is-visible');
      }
    });
  } else {
    showAllRevealItems();
  }

  if (allowMotion && revealItems.length && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('ss-await');
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.16,
      }
    );

    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    showAllRevealItems();
  }

  const tiltItems = Array.from(document.querySelectorAll('[data-ss-tilt]'));
  const zoomItems = Array.from(
    document.querySelectorAll('.ss-product-ritual-card__media, .template-product .product__media')
  );
  const addToCartForms = Array.from(document.querySelectorAll('[data-ss-add-to-cart]'));
  const buyNowForms = Array.from(document.querySelectorAll('[data-ss-buy-now]'));

  const getCartHost = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  // Section IDs the cart drawer / notification needs re-rendered after an add.
  const getCartSectionIds = () => {
    const host = getCartHost();
    const ids = ['cart-icon-bubble'];

    if (host && typeof host.getSectionsToRender === 'function') {
      try {
        host.getSectionsToRender().forEach((section) => {
          const id = section.section || section.id;
          if (id && !ids.includes(id)) ids.push(id);
        });
      } catch (error) {
        // Fall back to the cart bubble only.
      }
    }

    return ids;
  };

  const setBusy = (button, label) => {
    if (!button) return;
    if (button.dataset.ssIdleLabel === undefined) {
      button.dataset.ssIdleLabel = button.textContent.trim();
    }
    button.dataset.ssBusy = String(Date.now());
    button.disabled = true;
    button.textContent = label;
  };

  const resetButton = (button) => {
    if (!button) return;
    delete button.dataset.ssBusy;
    button.disabled = false;
    button.removeAttribute('title');
    if (button.dataset.ssIdleLabel) {
      button.textContent = button.dataset.ssIdleLabel;
    }
  };

  // The browser restores this page from the back/forward cache with the DOM
  // exactly as it was left, so a "Redirecting..." button stays disabled forever
  // after the user hits Back. Clear any stuck busy state when the page is shown.
  const resetAllBusyButtons = (minAge = 0) => {
    document.querySelectorAll('[data-ss-busy]').forEach((button) => {
      const startedAt = Number(button.dataset.ssBusy) || 0;
      if (Date.now() - startedAt >= minAge) resetButton(button);
    });
  };

  window.addEventListener('pageshow', () => resetAllBusyButtons());
  window.addEventListener('popstate', () => resetAllBusyButtons());
  document.addEventListener('visibilitychange', () => {
    // Only clear stale states here so a tab switch never cancels a live request.
    if (document.visibilityState === 'visible') resetAllBusyButtons(4000);
  });

  const submitCartRequest = async (form, { withSections = true } = {}) => {
    const action = form.getAttribute('action') || '/cart/add';
    const endpoint = action.endsWith('.js') ? action : `${action}.js`;
    const body = new FormData(form);

    if (withSections) {
      body.append('sections', getCartSectionIds().join(','));
      body.append('sections_url', window.location.pathname);
    }

    const response = await fetch(endpoint, {
      method: 'POST',
      body,
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    const payload = await response.json().catch(() => null);

    if (!response.ok || (payload && payload.status)) {
      const error = new Error((payload && (payload.description || payload.message)) || 'Cart request failed');
      error.payload = payload;
      throw error;
    }

    return payload;
  };

  // Hand the freshly rendered sections to Dawn so the drawer, the cart bubble
  // and any cart subscribers actually reflect the new line item.
  const updateCartBubble = (payload) => {
    const html = payload && payload.sections && payload.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (html && bubble) bubble.innerHTML = html;
  };

  const renderCartState = (payload) => {
    if (!payload) return;

    const host = getCartHost();

    try {
      if (host && payload.sections && typeof host.renderContents === 'function') {
        const inner = host.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        host.classList.remove('is-empty');
        host.renderContents(payload);
      } else {
        updateCartBubble(payload);
      }
    } catch (error) {
      // The item is in the cart even if the drawer failed to repaint.
      updateCartBubble(payload);
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'seventhsense-quick-add',
        productVariantId: payload.variant_id || payload.id,
        cartData: payload,
      });
    }
  };

  if (addToCartForms.length && window.fetch && window.FormData) {
    addToCartForms.forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[data-ss-add-label]') || form.querySelector('button[type="submit"]');
        const status = form.querySelector('[data-ss-cart-status]');

        if (button && button.dataset.ssBusy) return;

        setBusy(button, 'Adding...');
        if (status) status.textContent = '';

        const host = getCartHost();
        if (host && typeof host.setActiveElement === 'function') host.setActiveElement(button);

        try {
          const payload = await submitCartRequest(form);
          renderCartState(payload);

          if (button) button.textContent = 'Added';
          if (status) status.innerHTML = 'Added to cart. <a href="/cart">View cart</a>';

          window.setTimeout(() => resetButton(button), 1600);
        } catch (error) {
          const message = error.message || 'Could not add this item. Please try again.';

          if (status) {
            status.textContent = message;
            resetButton(button);
          } else if (button) {
            // No status slot in this card layout, so surface it on the button.
            button.textContent = 'Try again';
            button.setAttribute('title', message);
            window.setTimeout(() => resetButton(button), 2000);
          }
        }
      });
    });
  }

  if (buyNowForms.length && window.fetch && window.FormData) {
    buyNowForms.forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[data-ss-buy-now-label]') || form.querySelector('button[type="submit"]');

        if (button && button.dataset.ssBusy) return;

        setBusy(button, 'Redirecting...');

        try {
          await submitCartRequest(form, { withSections: false });
          window.location.href = `${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}checkout`.replace(
            '//checkout',
            '/checkout'
          );
        } catch (error) {
          resetButton(button);
        }
      });
    });
  }

  if (allowMotion && zoomItems.length && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    zoomItems.forEach((item) => {
      const image = item.querySelector('.ss-product-ritual-card__image, img');

      if (!image) return;

      item.addEventListener('pointermove', (event) => {
        const rect = item.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;

        image.style.transformOrigin = `${x.toFixed(1)}% ${y.toFixed(1)}%`;
      });

      item.addEventListener('pointerleave', () => {
        image.style.transformOrigin = '50% 50%';
      });
    });
  }

  if (allowMotion && tiltItems.length && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    tiltItems.forEach((item) => {
      item.addEventListener('pointermove', (event) => {
        const rect = item.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;

        item.style.setProperty('--ss-tilt-x', `${(-y * 7).toFixed(2)}deg`);
        item.style.setProperty('--ss-tilt-y', `${(x * 8).toFixed(2)}deg`);
      });

      item.addEventListener('pointerleave', () => {
        item.style.setProperty('--ss-tilt-x', '0deg');
        item.style.setProperty('--ss-tilt-y', '0deg');
      });
    });
  }

  const parallaxItems = Array.from(document.querySelectorAll('[data-ss-parallax]'));

  let ticking = false;

  const updateParallax = () => {
    const viewportHeight = window.innerHeight || 1;

    parallaxItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      const clamped = Math.min(Math.max(progress, 0), 1);
      const translateY = (0.5 - clamped) * 34;
      const rotateX = (0.5 - clamped) * 10;
      const rotateY = (clamped - 0.5) * 14;

      item.style.transform =
        `translate3d(0, ${translateY.toFixed(2)}px, 0) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg)`;
    });

    ticking = false;
  };

  const requestParallaxFrame = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  };

  if (allowMotion && parallaxItems.length) {
    requestParallaxFrame();
    window.addEventListener('scroll', requestParallaxFrame, { passive: true });
    window.addEventListener('resize', requestParallaxFrame);
  }

  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', (event) => {
      if (!event.matches) return;

      root.classList.remove('ss-motion-ready');
      showAllRevealItems();
      parallaxItems.forEach((item) => {
        item.style.transform = 'none';
      });
      tiltItems.forEach((item) => {
        item.style.setProperty('--ss-tilt-x', '0deg');
        item.style.setProperty('--ss-tilt-y', '0deg');
      });
    });
  }
})();
